;(function ( $ ) {

    /**
     *  overlay
     *  appends overlay to body and populates it with content loaded via ajax
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'overlay';
    var defaults = {
        selector: 'main'
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            if (!$(this.element).find('#atp-overlay').length) {
                this.renderOverlay();
            }
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(document).on('click', '.close-overlay', function(e) {
                e.preventDefault();
                _this.hideOverlay();
            });
            $(document).on('overlay.showLoading', function(e) {
                _this.showLoadingScreen();
            });
            $(document).on('overlay.show', function(e, params) {
                e.preventDefault();
                $('#atp-overlay').find('.form-step-progress').remove();
                if (params && params.bg && params.bg === 'gray') {
                    $('#atp-overlay').addClass('overlay-gray');
                } else {
                    $('#atp-overlay').removeClass('overlay-gray');
                }
                
                if (params && params.bg && params.bg === 'event') {
                    $('#atp-overlay').addClass('bg-color-event');
                } else {
                    $('#atp-overlay').removeClass('bg-color-event');
                }                
                if (params && params.size && params.size === 'small') {
                    $('#atp-overlay').addClass('small');
                    $('#atp-overlay .overlay-content').addClass('bg-color-event');
                } else {
                    $('#atp-overlay').removeClass('small');
                    $('#atp-overlay .overlay-content').removeClass('bg-color-event');
                }
                if ($('#atp-overlay').hasClass('is-hidden')) {
                    _this.showOverlay(params.clientX, params.clientY);
                } else {
                    $('#atp-overlay').find('.overlay-content').addClass('fadeOut animated fast');
                }
                if (params.href) {
                    _this.setOverlayContent(params.href, params.index, params.formData);
                }
                if (params.action) {
                    _this.setFormOverlayContent(params);
                }
                if($('html').hasClass('touch')){
                    
                    $('#atp-overlay').css({position: 'absolute'});
                    $('body, html').css({'overflow': 'hidden'});

                    $('#atp-overlay').show();
                    setTimeout(function (){
                        window.scrollTo(0, 0);
                        $('body, html').css({'max-height': '500px'});
                    },0);
                }
            });
            $('#atp-overlay').on('click', '.overlay-close, .close-overlay', function(e) {
                e.preventDefault();
                if (history.pushState) {
                    window.history.pushState({}, '', window.location.protocol + "//" + window.location.host + window.location.pathname);
                }
                _this.hideOverlay();
            });
            $(window).on('overlay.close', function() {
                if (history.pushState) {
                    window.history.pushState({}, '', window.location.protocol + "//" + window.location.host + window.location.pathname);
                }
                _this.hideOverlay();
            });
            $('#atp-overlay').on('click', '.overlay-back, .back-overlay', function(e) {
                e.preventDefault();
                if(!$('#atp-overlay').find('.overlay-back').hasClass('edit')){
                    window.history.back();
                }
                else {
                    $(window).trigger('ticketform.show');
                }
            });
            $(window).on('overlay.back', function() {
                window.history.back();
            });
            window.addEventListener("hashchange", (function (e) {
                console.info(window.location.hash);
                if(window.location.hash.substr(0,2) == "#/") {
                    _this.setOverlayContent(window.location.hash.substr(2), null, null);
                    $('#atp-overlay').find('.form-step-progress').remove();
                }
                else {
                    _this.hideOverlay();
                }
            }));
            $(document).keyup(function(e) {
                if (e.keyCode == 27) { // escape
                    _this.hideOverlay();
                }
            });
        },

        setOverlayContent: function(url, index, formData) {
            var _this = this;
            this.showLoadingScreen();
            $.ajax({
                type : 'get',
                url : url,
                cache : false,
                async : false,
                dataType : 'html',
                error : function() {
                    // no notification at the moment
                    $('#atp-overlay').find('.overlay-content').empty().removeClass('fadeOut').html('<h1>ERROR!</h1>').addClass('fadeIn animated fast');
                },
                success : function(data) {
                    $('#atp-overlay').find('.overlay-content')
                        .empty()
                        .animate({'scrollTop': 0 })
                        .append('<a class="overlay-close color-light color-event-hover" href="#"><span class="icon icon-close"></span></a>')
                        .append('<a class="overlay-back color-light color-event-hover" href="#"><span class="icon icon-arrow-left"></span></a>');
                    var html = jQuery.parseHTML(data, document, true);
                    $.each(html, function(index, elem) {
                        // if the element's id matches the outer if, append the childs only
                        if (elem.tagName && (elem.tagName.toLowerCase() == _this.settings.selector)) {
                            $('#atp-overlay').find('.overlay-content').append($(elem));
                        }
                    });
                    $('#atp-overlay').find('.overlay-content').removeClass('fadeOut').addClass('fadeIn animated fast');
                    if (index !== undefined) {
                        $('#atp-overlay').find('form').append('<input type="hidden" name="index" value="' + index + '" />');
                        if (formData) {
                            $('#atp-overlay').find('form').find('select[name="salutation"]').find('option[value="' + formData.salutation + '"]').attr('selected', 'selected');
                            $('#atp-overlay').find('form').find('select[name="title"]').find('option[value="' + formData.title + '"]').attr('selected', 'selected');
                            $('#atp-overlay').find('form').find('select[name="country"]').find('option[value="' + formData.country + '"]').attr('selected', 'selected');
                            $('#atp-overlay').find('form').find('input[name="givenname"]').val(formData.givenname);
                            $('#atp-overlay').find('form').find('input[name="surname"]').val(formData.surname);
                            $('#atp-overlay').find('form').find('input[name="company"]').val(formData.company);
                            $('#atp-overlay').find('form').find('input[name="email"]').val(formData.email);
                        }
                    }
                    initPlugins($('#atp-overlay'));
                }
            });
        },

        setFormOverlayContent: function(params) {
            var _this = this;
            $.ajax(params.action, {
                beforeSend: _this.showLoadingScreen,
                method: params.method,
                data: params.formData,
                dataType: 'html',
                success: function(data, status, jqXHR) {
                    var $main = $('<div/>').append(data).find(_this.settings.selector);
                    $('#atp-overlay').find('.overlay-content')
                        .empty()
                        .append('<a class="overlay-close color-light color-event-hover" href="#"><span class="icon icon-close"></span></a>')
                        .append('<a class="overlay-back color-light color-event-hover" href="#"><span class="icon icon-arrow-left"></span></a>')
                        .css('overflow', 'auto')
                        .append($main)
                        .removeClass('fadeOut')
                        .addClass('fadeIn animated fast');
                    initPlugins($('#atp-overlay'));
                },
                error: function() {
                    $('#atp-overlay').find('.overlay-content').empty().removeClass('fadeOut').html('<h1>ERROR!</h1>').addClass('fadeIn animated fast');
                }
            });

        },

        showOverlay: function(clientX, clientY) {
            if (!clientX) {
                clientX = $(window).width() / 2;
            }
            if (!clientY) {
                clientY = $(window).height() / 2;
            }
            var top = clientY - 10;
            var bottom = clientY + 10;
            var left = clientX - 10;
            var right = clientX + 10;
            var width = 20;
            var height = 20;

            $('#atp-overlay').find('.overlay-content').hide();
            // $('#atp-overlay').find('.overlay-close').hide();
            $('#atp-overlay').css({
                'width': width,
                'height': height,
                'top': top,
                'left': left,
                'bottom': bottom,
                'right': right
            }).animate({
                'width': '100%',
                'height': '100%',
                'top': '36px',
                'left': 0,
                'bottom': 0,
                'right': 0
            }, 200, 'easeInOutQuad', function() {
                // animation complete
               $('#atp-overlay').find('.overlay-content').show().addClass('animated fadeIn fast');
               if (!$('#atp-overlay').find('.overlay-close').length) {
                    $('#atp-overlay').find('.overlay-content')
                        .append('<a class="overlay-close color-light color-event-hover" href="#"><span class="icon icon-close"></span></a>')
                        .append('<a class="overlay-back color-light color-event-hover" href="#"><span class="icon icon-arrow-left"></span></a>');
               }
               // $('#atp-overlay').find('.overlay-close').show();
            });
            $('#atp-overlay').removeClass('fadeOut').removeClass('is-hidden').addClass('animated fadeIn fast');
            $(this.element).addClass('noscroll');
        },

        hideOverlay: function() {
            $(this.element).removeClass('noscroll');
            // $('#atp-overlay').find('.overlay-close').hide();
            $('#atp-overlay').removeClass('fadeIn').addClass('fadeOut');
            window.setTimeout(function() {
                $('#atp-overlay').addClass('is-hidden');
                $('#atp-overlay').removeClass('fadeOut').removeClass('animated').removeClass('fast');
                if($('html').hasClass('touch')){
                    $('body, html').css({'overflow': 'auto'});
                    $('body, html').css({'max-height': 'initial'});
                    $('footer').css({'position': 'relative'});
                }
            }, 200);
            
            $(document).off('touchmove');
        },

        showLoadingScreen: function() {
            $('#atp-overlay')
                .find('.overlay-content')
                .empty()
                .removeClass('fadeIn').removeClass('fadeOut').removeClass('animated').removeClass('fast')
                .append('<div class="overlay-loading"><div class="loading-indicator"><span></span></div></div>');
        },

        renderOverlay: function() {
            var html = '<div class="overlay is-hidden" id="atp-overlay" style="z-index: 9900;">' +
                '<div class="overlay-content"></div></div>';
            $(this.element).append(html);
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
